export default "__VITE_ASSET__Dh287zEA__"